import React from 'react';
import './App.css';
import Main from './components/main';
//import { Link } from 'react-router-dom';

const App = () => <Main />;

export default App;
